<template>
  <v-container>
    <v-row
      v-if="noSimulationsFound"
      class="mb-5"
    >
      <v-col
        cols="12"
        class="headline"
      >
        <v-alert type="error">
          No token found, please use your invite link!
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      v-for="(group, i) in simulationGroups"
      :key="`group-${i}`"
      class="mb-5"
    >
      <v-col
        cols="12"
        class="headline"
      >
        {{ group.vendor }}
        <v-divider></v-divider>
      </v-col>
      <v-col
        v-for="(product, j) in group.products"
        :key="`product-${i}-${j}`"
        cols="3"
      >

        <router-link
          :to="product.latestSimulation.to"
        >
          {{ product.latestSimulation.vendor }} {{ product.latestSimulation.product }}
        </router-link>

        <v-menu offset-y v-if="product.olderSimulations.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              text
              icon
            >
              <v-icon >
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <v-list
              max-height=500
              width=200
              color=argb(100,100,100,0.5)
            >
            <v-list-item
              v-for="(simulation, k) in product.simulations"
              :key="`simulation-${i}-${j}-${k}`"
              :to="simulation.to"
            >
              <v-list-item-title>{{ simulation.version }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import state from '@/state';

export default {
  data: () => ({
  }),

  mounted() {
    state.runAsync(async () => {
      await state.simulationsPromise;
    });
  },

  computed: {
    token() {
      return state.token;
    },

    simulations() {
      return state.simulations.slice(0);
    },

    noSimulationsFound() {
      return (state.simulationsLoaded && (this.simulations.length === 0));
    },

    simulationGroups() {
      const vendorSet = this.simulations.reduce((memo, sim) => {
        memo.add(sim.vendor);
        return memo;
      }, new Set());

      const vendors = Array.from(vendorSet.values());
      vendors.sort((l, r) => {
        let result;
        if (l === r) {
          result = 0;
        } else if (l === 'RESOL') {
          result = -1;
        } else if (r === 'RESOL') {
          result = 1;
        } else if (l < r) {
          result = -1;
        } else if (l > r) {
          result = 1;
        } else {
          result = 0;
        }
        return result;
      });

      function cmpExistAndOrder(l, r) {
        if (!l && !r) return 0;
        if (!r) return -1;
        if (!l) return 1;
        if (l < r) return -1;
        if (l > r) return 1;
        return 0;                 // <- equal
      }

      function compareVersions(l, r) {
        let result = 0;
        const re = /^(\d+\.\d+)(?:(?: |-)(?:(rc\d+)|(P\d+)(-T\d+)?))?$/;

        const mdL = re.exec(l);
        const mdR = re.exec(r);

        for (let i = 1; i <= 4 && result == 0; i++) {
            result = cmpExistAndOrder(mdL[i], mdR[i]);
        }
        return result;
      }

      return vendors.map(vendor => {
        const simulations = this.simulations.filter(sim => sim.vendor === vendor);

        simulations.sort((l, r) => {
          let result;
          if (l.product < r.product) {
            result = -1;
          } else if (l.product > r.product) {
            result = 1;
          } else {
            result = compareVersions(l.version, r.version);
          }
          return result;
        });

        const products = simulations.reduce(
          (products, sim) => {

            let product = products.find( x => x.product === sim.product );
            if (!product) {
              product = {
                product: sim.product,
                simulations: []
              };
              products.push(product);
            }
            product.simulations.push(sim);

            return products;
          },
          []
        );

        for ( const product of products ) {
          product.latestSimulation = product.simulations[product.simulations.length-1];
          product.olderSimulations = product.simulations.slice(0,product.simulations.length-1);
        }

        return {
          vendor,
          products
        };
      });
    },
  },
};
</script>
